"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Engine = void 0;
const murmurHash3_1 = require("./murmurHash3");
class Engine {
    constructor({ segments, flags, uniqueId, verbose = false }) {
        this.segments = segments;
        this.flags = flags;
        this.uniqueId = uniqueId;
        this.verbose = verbose;
    }
    evalAll({ context, }) {
        const matchedSegments = this.matchSegments(context);
        const result = this.flags.map((flag) => {
            return {
                name: flag.name,
                variant: this.evalWithMatchedSegments(flag, matchedSegments),
            };
        });
        return result;
    }
    eval({ flagName, context }) {
        const flag = this.findFlag(flagName);
        const matchedSegments = this.matchSegments(context);
        const variant = this.evalWithMatchedSegments(flag, matchedSegments);
        return variant;
    }
    evalWithMatchedSegments(flag, matchedSegments) {
        if (!flag || !flag.variants) {
            return undefined;
        }
        if (flag.disabled) {
            return undefined;
        }
        if (!matchedSegments || matchedSegments.length === 0) {
            return this.getDefault(flag);
        }
        if (!Array.isArray(flag.rules) || flag.rules.length === 0) {
            return this.getDefault(flag);
        }
        if (matchedSegments.length === 0) {
            return this.getDefault(flag);
        }
        const matchedRule = this.findRuleForSegment(flag, matchedSegments);
        if (!matchedRule) {
            return this.getDefault(flag);
        }
        const matchedVariant = this.resolveRule(flag.name, matchedRule);
        if (!matchedVariant) {
            this.log('Unable to match variant :(');
            return this.getDefault(flag);
        }
        const variants = flag.variants;
        const variant = variants.find((v) => v.name === matchedVariant);
        if (!variant) {
            this.log(`flag.variant ${matchedVariant} not defined`);
            return this.getDefault(flag);
        }
        return variant;
    }
    resolveRule(flagName, rule) {
        if (typeof rule.splits === 'undefined') {
            this.log('rule.splits is not defined');
            return undefined;
        }
        const seed = murmurHash3_1.hash32(flagName, 42);
        const bucket = this.getBucket(this.uniqueId, seed);
        if (bucket < 0 || bucket > 100) {
            this.log(`Bucket ${bucket} for flag ${flagName} out of bounds 0 to 100.`);
            return undefined;
        }
        const buckets = [];
        const variants = [];
        let currentSize = 0;
        for (const split of rule.splits) {
            currentSize += split.size;
            buckets.push(currentSize);
            variants.push(split.variant);
        }
        const variantIndex = buckets.findIndex((b) => b >= bucket);
        const matchedVariant = variants[variantIndex];
        return matchedVariant;
    }
    getDefault(flag) {
        if (!flag || !flag.defaultVariant) {
            return undefined;
        }
        const variants = flag.variants;
        const defaultVariant = variants.find((v) => v.name === flag.defaultVariant);
        return defaultVariant;
    }
    findRuleForSegment(flag, matchedSegments) {
        return flag.rules.find((rule) => this.ruleMatchesSegment(rule, matchedSegments));
    }
    ruleMatchesSegment(rule, matchedSegments) {
        if (!rule.segmentMatch) {
            return true;
        }
        if (Array.isArray(rule.segmentMatch)) {
            return rule.segmentMatch.every((segmentMatch) => {
                return segmentMatch.value.some((segment) => matchedSegments.includes(segment));
            });
        }
        if (!Array.isArray(rule.segmentMatch)) {
            if (!Array.isArray(rule.segmentMatch.value)) {
                this.log('rule.segmentMatch.value is not an array');
                return false;
            }
            if (rule.segmentMatch.value.length === 0) {
                return true;
            }
            return rule.segmentMatch.value.some((segment) => matchedSegments.includes(segment));
        }
    }
    findFlag(name) {
        return this.flags.find((f) => f.name === name);
    }
    matchSegments(context) {
        return this.segments
            .filter((segment) => {
            return this.contextMatchesSegment(segment, context);
        })
            .map((s) => s.name);
    }
    contextMatchesSegment(segment, context) {
        if (typeof segment.match === 'undefined' || segment.match.length === 0) {
            return false;
        }
        return segment.match.every((match) => this.matchContextValue(match, context));
    }
    matchContextValue(match, context) {
        const contextValue = context[match.key];
        switch (match.operator) {
            case 'eq':
                return match.value === contextValue;
            case 'in':
                if (Array.isArray(match.value)) {
                    return match.value.includes(contextValue);
                }
                return false;
            default:
                this.log(`match.${match.operator} criteria is not supported.`);
                return false;
        }
    }
    getBucket(str, seed) {
        return Math.abs(murmurHash3_1.hash32(str, seed) % 100) + 1;
    }
    log(message) {
        if (this.verbose) {
            console.log(message);
        }
    }
}
exports.Engine = Engine;
//# sourceMappingURL=engine.js.map